import * as React from "react";

import { InputLabel, TextField, TextFieldProps } from "@mui/material";
import useStyles from "./AppTextField.styles";
import { useState } from "react";
import { useRouter } from "next/router";

export type IDropdownItem = {
  label: string;
  value: number;
};

export type AppTextFieldProps = {
  label?: string;
  width?: string;
  height?: string;
  line?: number;
  required?: boolean;
} & Omit<TextFieldProps, "variant">;

const AppTextField = (
  props: AppTextFieldProps,
  ref: React.ForwardedRef<any>
) => {
  const {
    className,
    label,
    width,
    classes: muiClasses,
    fullWidth,
    error,
    required,
    id,
    disabled,
    sx,
    placeholder,
    line,
    defaultValue,
    onChange,
    value,
    ...rest
  } = props;

  const { locale } = useRouter();

  const [isError, setIsError] = useState<boolean>(false);

  let handleChanges = (e: any) => {
    setIsError(e.target.value.length === 0);
    if (props.onChange) props.onChange(e);
  };

  let handleFocus = (e: any) => {
    setIsError(e.target.value.length === 0);
  };

  const { classes } = useStyles({
    params: {
      locale: locale!,
      required: props.required ?? false,
      isError: isError,
      width: props.width ?? "100%",
    },
  });

  return (
    <div className={classes.formControl} ref={ref}>
      <InputLabel required={props.required}>
        <span className={classes.labelText}>{props.label}</span>
      </InputLabel>
      <TextField
        id={id}
        variant="outlined"
        defaultValue={props.defaultValue}
        required
        error={props.error}
        onChange={handleChanges}
        onFocus={handleFocus}
        helperText={props.helperText}
        className={classes.textField}
        multiline={props.multiline}
        rows={props.rows}
        placeholder={props.placeholder}
        value={value}
      />
    </div>
  );
};

export default React.forwardRef(AppTextField);
